import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/common/services/auth/auth.service';
import { Animations } from 'src/app/common/utilities/animations';
import { EnvironmentService } from 'src/app/common/services/environment/environment.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [Animations.fadeInOut, Animations.delayfadeInOut],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  submitted = false;

  loading = false;

  errorMessage: string | null;

  growelabGoogleClientId: string;

  liwcLink: string;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.growelabGoogleClientId = EnvironmentService.growelabGoogleClientId();
    this.liwcLink = `https://clever.com/oauth/authorize?response_type=code&client_id=${EnvironmentService.cleverClientId()}&redirect_uri=${encodeURIComponent(
      EnvironmentService.cleverRedirectURI()
    )}`;
    this.errorMessage = window.localStorage.getItem('loginError');
    window.localStorage.removeItem('loginError');
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).handleGSIResponse = this.handleGSIResponse;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleGSIResponse = (response: any) => {
    this.loading = true;

    this.authService.googleLogin(response).subscribe({
      error: (err) => {
        this.loading = false;
        this.errorMessage = err.error.message;
        this.cdr.detectChanges();
      },
    });
  };

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;

    this.authService
      .login(this.f['username'].value, this.f['password'].value)
      .subscribe({
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
        },
      });
  }
}
